module.exports = __webpack_public_path__ + "static/gitlet-thumb-adc4aa415c87a28ac5ef40e0209d3097.png";